import { render, staticRenderFns } from "./ThesisStudent.vue?vue&type=template&id=7ad16286"
import script from "./ThesisStudent.vue?vue&type=script&lang=js"
export * from "./ThesisStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports